import React, { useEffect, useRef, useState } from "react";
import styles from "./devoteeBooking.module.scss";
import commonStyles from "../../../App.module.scss";
import CloseIcon from "@mui/icons-material/Close";
import constants from "../../../config/constants.json";
import {
  CommonButton,
  CommonOutlinedButton,
  CustomDatePicker,
  CustomRequiredInputLabel,
  CustomRadioButton,
  CustomSelect,
  CustomTextFeild,
  StyledDateContainer,
  CustomCalendarTodayOutlinedIcon,
  CustomMenuItem,
  CustomCheckbox,
  CustomBadge,
  CustomLeftIcon,
  formatAmount,
} from "../../common/StyledComponents/StyledFields";
import {
  FormControl,
  FormControlLabel,
  Grid,
  Typography,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import InputAdornment from "@mui/material/InputAdornment";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import dayjs from "dayjs";
import deleteIcon from "../../../assets/svg/delete_outline.svg";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useNavigate } from "react-router-dom";
import ModeofPayment from "../../common/modeOfPayment/modeOfPayment";
import { ValidationError, number, object, string } from "yup";
import {
  apiRequest,
  catchErrorMessageHandler,
  getUserDetails,
  getUserName,
} from "../../../infrastructure/backendService";
import toast, { Toaster } from "react-hot-toast";
import HcccTimePicker from "../../common/customTimePicker/hcccTimePicker";
import apiPath from "../../../config/apiPaths.json";
import {
  DietiesListByPoojaIdProps,
  PoojaTypeListProps,
  PriestListProps,
  cartItemListProps,
} from "../../../infrastructure/GlobalContextProvider";
import { isBoolean, isEmpty, isNil } from "lodash";
import IconButton from "@mui/material/IconButton";
import cartIcon from "../../../assets/svg/Cart.svg";
import LOCALE from "../../../config/en-us.json";
import { ClipLoader } from "react-spinners";
import SuccessPopup from "../donation/successPopup";
import ErrorPopup from "../../common/ErrorPopup";
import { BounceLoader } from "react-spinners";
import { CartComponent } from "../../common/cartItemsComponent/cartComponent";
import { RoutingURLs } from "../../common/RoutingURLs";
import { getStartTimeAndEndTime, handlePoojaTimeChangeSetErrors } from "../../common/handleTimeChangeSetErrors";

interface DonationServiceProps {
  showHeaders?: boolean;
}

interface PoojaItem {
  id?: number | null | undefined;
  name: string | null;
  poojaTitle: string;
  deities: string;
  dateOfPooja: string;
  donationAmount: number;
  poojaLocation: string;
  poojaTime: string;
  selectPriest: string;
  poojaDuration: number;
}
type ErrorPoojaItem = {
  name: string;
  poojaTitle: string;
  deities: string;
  dateOfPooja: string;
  donationAmount: string;
  poojaLocation: string;
  poojaTime: string;
  selectPriest: string;
};

const DevoteeBookPooja = (props: DonationServiceProps) => {
  const [currentItem, setCurrentItem] = useState<PoojaItem>({
    name: getUserName() || "",
    poojaLocation: "TEMPLE_POOJA",
    poojaTitle: "",
    deities: "",
    dateOfPooja: dayjs().format("MM-DD-YYYY"),
    donationAmount: 0,
    poojaTime: dayjs().format("hh:mm A"),
    selectPriest: "",
    poojaDuration: 0,
  });

  const [errorMessage, setErrorMessage] = useState<ErrorPoojaItem>({
    name: "",
    poojaLocation: "",
    poojaTitle: "",
    deities: "",
    dateOfPooja: "",
    donationAmount: "",
    poojaTime: "",
    selectPriest: ""
  });
  const [totalDonationAmount, setTotalDonationAmount] = useState<number>(0);
  const [selectedId, setSelectedId] = useState<number | null | undefined>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const navigate = useNavigate();
  const [poojaItemsList, setPoojaItemsList] = useState<PoojaTypeListProps[]>(
    []
  );
  const [poojaDeitiesList, setPoojaDeitiesList] = useState<
    DietiesListByPoojaIdProps[]
  >([]);
  const [showDeities, setShowDeities] = useState(false);
  const [priestList, setPriestList] = useState<PriestListProps[]>([]);
  const [showPriestDropdown, setShowPriestDropdown] = useState<boolean>(false);
  const [buttonDisable, setButtonDisable] = useState<boolean>(false);
  const [priestSelected, setPriestSelected] = useState<boolean>(false);
  const [showList, setShowList] = useState<boolean>(false);
  const [selectedDeityIds, setSelectedDeityIds] = useState<number[]>([]);
  const [selectedPoojaId, setSelectedPoojaId] = useState<number | undefined>(0);
  const [selectedPriestId, setSelectedPriestId] = useState<string | undefined>(
    ""
  );
  const [cartItemsList, setcartItemsList] = useState<cartItemListProps[]>([]);
  const [cartItemIds, setCartItemIds] = useState<any[]>([]);
  const [paymentButton, setpaymentButton] = useState(true);
  const [loading, setLoading] = useState(false);
  const [deityError, setDeityError] = useState<string>("");
  const [showDetails, setShowDetails] = useState<boolean>(false);
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  const [isDatePickerOpen, setDatePickerOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState<number[]>(selectedDeityIds);
  const [donationAmount, setDonationAmount] = useState(0);
  const [duration, setDuration] = useState(0);

  const getHeaders = (): boolean => {
    if (
      !isNil(props.showHeaders) &&
      isBoolean(props.showHeaders) &&
      props.showHeaders === false
    ) {
      return false;
    } else {
      return true;
    }
  };

  const maxFieldLimit = constants.Maximum_Field_LIMIT; 

  const validationSchema = object().shape({
    name: string().required("Name is required"),
    poojaLocation: string().required("Pooja Location is required"),
    poojaTitle: string().required("Pooja Title is required"),
    dateOfPooja: string().required("Pooja Date is required"),
    donationAmount: number()
      .required("Donation amount is required")
      .min(1, "Minimum donation amount is 1").max(maxFieldLimit, "Maximum donation amount reached")
      .transform((value, originalValue) => {
        return originalValue === "" ? undefined : value;
      }),
    poojaTime: string().required("Pooja Time is required"),
    selectPriest: showPriestDropdown ? string().required("Priest is required"): string()
  });

  const validateDonationSchema = number()
    .required("Donation amount is required")
    .min(1, "Minimum donation amount is 1")
    .max(maxFieldLimit, "Maximum donation amount reached")
    .transform((value, originalValue) => {
      return originalValue === "" ? undefined : value;
    });

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.poojaTypeByPoojaLocation,
      params: {
        poojaType: currentItem.poojaLocation,
      },
      includeToken: true,
    })
      .then((res) => {
        setPoojaItemsList(res.data);
      })
      .catch((err) => {
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  }, [currentItem.poojaLocation]);

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.priestList,
      includeToken: true,
    })
      .then((res) => {
        setPriestList(res.data);
      })
      .catch((err) => {
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  }, []);

  useEffect(() => {
    getCartItems();
  }, []);


  useEffect(() => {
    // Recalculate donation amount whenever currentItem or selectedItems change
    setDonationAmount(calculateDonationAmount(currentItem));
    setDuration(calculateDuration(currentItem));
    setErrorMessage((prevState) => ({...prevState, donationAmount: ""}))
  }, [currentItem.poojaTitle, selectedDeityIds]);

  const getDeitiesListByPoojaId = (id: number | undefined) => {
    if (!isNil(id)) {
      apiRequest({
        method: "GET",
        endpoint: apiPath.deitiesListByPoojaId,
        includeToken: true,
        params: {
          poojaId: id,
        },
      })
        .then((res) => {
          setPoojaDeitiesList(res.data);
        })
        .catch((err) => {
          console.log(err);
          toast.custom(
            <ErrorPopup
              showMessage={catchErrorMessageHandler(err)}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
            />,
            {
              duration: constants.TOAST_POPUP_DURATION,
            }
          );
        });
    }
  };

  const handleMakePayment = () => {
    // makePaymentApiCall();
    sessionStorage.setItem("cartItems", JSON.stringify(cartItemIds));
    navigate(
      `/creditPayment?amount=${totalDonationAmount}&donationType=bookPooja`
    );
  };

  const handleDateChange = (field: keyof PoojaItem, value: any) => {
    const formattedDate = dayjs(value, "MM-DD-YYYY");
    // setCurrentItem((prevItem) => ({ ...prevItem, [field]: formattedDate.isValid() ? formattedDate.format('MM-DD-YYYY') : '' }));
    setCurrentItem({
      ...currentItem,
      [field]: formattedDate.isValid()
        ? formattedDate.format("MM-DD-YYYY")
        : "",
    });
  };

  const handleFieldChange = (field: any, value: any) => {
    setCurrentItem((prevItem: any) => ({ ...prevItem, [field]: value }));
    if (field !== "poojaTime") {
      setErrorMessage({ ...errorMessage, [field]: "" });
    }
  };


  const handleDropdowmChange = (field: any, value: any) => {
    setShowDeities(true);
    setSelectedItems([]);
    setButtonDisable(false);
    setErrorMessage({ ...errorMessage, [field]: "" });
    if (field === "poojaTitle") {
      setCurrentItem((currentItem) => ({
        ...currentItem,
       selectPriest: ""
      }));
      setSelectedDeityIds([]);
      setShowDetails(true);
      const selectedPooja = poojaItemsList.find(
        (item: PoojaTypeListProps) => item.name === value
      );
      setSelectedPoojaId(selectedPooja?.id);
      getDeitiesListByPoojaId(selectedPooja?.id);
      // Check if priest is required for the selected pooja
      if (selectedPooja && selectedPooja.priestRequired) {
        setShowPriestDropdown(true);
        // Show the priest list dropdown
      } else {
        setShowPriestDropdown(false);
        setPriestSelected(false);
        // Hide the priest list dropdown
      }
      setPriestSelected(false);

      // Set the suggested donation amount for the selected pooja
      setErrorMessage({ ...errorMessage, donationAmount: "" });
      setCurrentItem((prevItem) => ({
        ...prevItem,
        donationAmount: selectedPooja ? selectedPooja.suggestedDonation : 0,
        poojaDuration: selectedPooja ? selectedPooja.duration : 0,
      }));
      setCurrentItem((prevItem) => ({ ...prevItem, [field]: value }));
    } else if (field === "selectPriest") {
      const selectedPriestIds = priestList.find(
        (item: PriestListProps) => item.priest_id === value
      );
      setPriestSelected(true);
      setCurrentItem((prevItem) => ({ ...prevItem, [field]: value }));
      // setButtonDisable(false);
      setSelectedPriestId(selectedPriestIds?.priest_id);
    } else {
      setCurrentItem((prevItem) => ({ ...prevItem, [field]: value }));
      // setShowDeities(true);
      setPriestSelected(false);
    }
  };

  const getCartItems = () => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.cartItems,
      includeToken: true,
    })
      .then((res) => {
        setShowList(false);
        const cartItemObjects = res.data.bookedItemInCart.map(
          (item: cartItemListProps) => ({
            itemId: item.id, // Create an object with itemId as the key and item's id as the value
          })
        );
        setcartItemsList(res.data.bookedItemInCart);
        setCartItemIds(cartItemObjects);
        setTotalDonationAmount(res.data.totalAmount);
        setPriestSelected(false);
        setShowPriestDropdown(false);
        setSelectedPriestId("");
        setSelectedDeityIds([]);
        setSelectedPoojaId(0);
        setPoojaDeitiesList([]);
      })
      .catch((err) => {
        console.log(err);
        setShowList(false);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const sendRequestApi = () => {
    if (
      selectedDeityIds.length === 0 &&
      priestSelected === false &&
      poojaDeitiesList.length !== 0
    ) {
      setDeityError("Deity is Mandatory,Please Select Deity.");
    } else {
      const reqBody = {
        onBehalfOfUsername: getUserName()?.toUpperCase(),
        poojaType: currentItem.poojaLocation,
        poojaId: selectedPoojaId,
        priestId: priestSelected ? currentItem.selectPriest : "",
        deityIds: selectedDeityIds,
        poojaDate: currentItem.dateOfPooja,
        durationInMinutes: duration.toString(),
        amount: donationAmount.toString(),
        description: "",
        priestRequired: priestSelected,
        poojaTime: currentItem.poojaTime,
      };
      setLoading(true);
      apiRequest({
        method: "POST",
        endpoint: apiPath.devoteePoojaBookingRequest,
        body: JSON.stringify(reqBody),
        includeToken: true,
      })
        .then((res) => {
          // toast.custom(
          //   <ToastSuccess
          //     message= {priestSelected ? LOCALE.BOOKING_REQUEST : LOCALE.ADDED_TO_CART}
          //     sent={LOCALE.ITEM_ADDED}
          //   />
          // );
          toast.custom(
            <SuccessPopup
              headerMessage="Booking Request"
              showMessage={
                priestSelected ? LOCALE.BOOKING_REQUEST : LOCALE.ADDED_TO_CART
              }
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              
            />,
            {
              duration: constants.TOAST_POPUP_DURATION,
            }
          );
          onClickCancel();
          setLoading(false);
          if (priestSelected) {
            navigate(RoutingURLs.dashboard);
          } else {
            getCartItems();
          }
          setShowDetails(false);
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
          toast.custom(
            <ErrorPopup
              showMessage={catchErrorMessageHandler(err)}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
            />,
            {
              duration: constants.TOAST_POPUP_DURATION,
            }
          );
        });
    }
  };

  const handleSave = async (): Promise<void> => {
    const errors: ErrorPoojaItem = {
      name: "",
      poojaLocation: "",
      poojaTitle: "",
      deities: "",
      dateOfPooja: "",
      donationAmount: "",
      poojaTime: "",
      selectPriest: ""
    };

    let donationAmountError = ""
    let poojaTimeError = errorMessage.poojaTime;
    try {
      await validateDonationSchema.validate(donationAmount, {
        abortEarly: false,
      });
      // If validation passes, you can submit the form
      setErrorMessage({...errors, donationAmount: "", poojaTime: poojaTimeError});
    } catch (error: any) {
      if (error instanceof ValidationError) {
        donationAmountError = error.message
        setErrorMessage({ ...errors, donationAmount: error.message, poojaTime: poojaTimeError });
      }
    }

    try {
      // Validate the form data against the validation schema
      await validationSchema.validate(currentItem, { abortEarly: false });

      if (!donationAmountError && !poojaTimeError) {
        setErrorMessage(errors)
        sendRequestApi();
      }
    } catch (error: any) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e: any) => {
          if (e.path) {
            errors[e.path as keyof ErrorPoojaItem] = e.message;
          }
        });
      }
      setErrorMessage({...errors, donationAmount: donationAmountError});
    }
  };

  const onClickCancel = () => {
    setCurrentItem({
      name: getUserName()?.toUpperCase() || "",
      poojaLocation: "TEMPLE_POOJA",
      poojaTitle: "",
      deities: "",
      dateOfPooja: dayjs().format("MM-DD-YYYY"),
      donationAmount: 0,
      poojaTime: dayjs().format("hh:mm A"),
      selectPriest: "",
      poojaDuration: 0,
    });
    setcartItemsList([]);
    setTotalDonationAmount(0);
    setPriestSelected(false);
    setShowPriestDropdown(false);
    setSelectedPriestId("");
    setSelectedDeityIds([]);
    setSelectedPoojaId(0);
    setPoojaDeitiesList([]);
    setErrorMessage({ ...errorMessage, poojaTime: ""});
    setShowDetails(false);
  };

  const deitiesListComponent = () => {
    return (
      <div style={{ width: "100%" }}>
        {CustomRequiredInputLabel("Deities", true)}
        <div className={styles.checkBoxContainer}>
          {poojaDeitiesList.map((item: DietiesListByPoojaIdProps, index) => (
            <div className={styles.checkTitle}>
              <FormControlLabel
                control={
                  <CustomCheckbox
                    id={`${index}`}
                    size="medium"
                    className={styles.checkbox}
                    checked={selectedDeityIds.includes(item.deityId)}
                    onChange={() => handleCheckboxChange(item.deityId)}
                  />
                }
                label={item.deityName}
              />
            </div>
          ))}
        </div>
        {!isEmpty(deityError) ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {deityError}
          </Typography>
        ) : (
          ""
        )}
      </div>
    );
  };

  const priestListDropdown = (): React.ReactElement => {
    return (
      <FormControl sx={{ width: "100%" }}>
        <CustomSelect
          id="selectPriest"
          IconComponent={KeyboardArrowDownIcon}
          placeholder="Select Priest"
          value={currentItem.selectPriest || ""}
          onChange={(e) => {
            handleDropdowmChange("selectPriest", e.target.value);
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
          className={
            errorMessage.poojaTitle ? styles.errorTextField : styles.textField
          }
        >
          {priestList.map((item: PriestListProps, index: number) => (
            <CustomMenuItem key={index} value={item.priest_id}>
              {item.priestname}
            </CustomMenuItem>
          ))}
        </CustomSelect>
        {errorMessage.selectPriest ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage.selectPriest}
          </Typography>
        ) : (
          ""
        )}
      </FormControl>
    );
  };

  const handleKeyPress = (e:any) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent the default form submission behavior
      handleSave();
    }
  };

  const buttonsComponent = (): React.ReactElement => {
    return (
      <div className={styles.buttonsContainer}>
        <CommonOutlinedButton onClick={onClickCancel} id="cancel">
          Reset
        </CommonOutlinedButton>
        <CommonButton
          onClick={handleSave}
          disabled={buttonDisable || loading}
          id="submit"
        >
          {loading ? (
            <>
              <ClipLoader color="#fff" loading={loading} size={15} />
              <span
                style={{
                  marginLeft: "8px",
                  fontSize: "15px",
                  textAlign: "center",
                }}
              >
                Please wait...
              </span>
            </>
          ) : priestSelected ? (
            "Send Request"
          ) : (
            "Add"
          )}
        </CommonButton>
      </div>
    );
  };

  const poojaTypesDropdown = (): React.ReactElement => {
    return (
      <FormControl sx={{ width: "100%" }}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          id="poojaTitle"
          placeholder="Select Pooja"
          value={currentItem.poojaTitle || ""}
          onChange={(e) => {
            handleDropdowmChange("poojaTitle", e.target.value);
            setErrorMessage({ ...errorMessage, poojaTitle: "", donationAmount: "" });
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
          className={
            errorMessage.poojaTitle ? styles.errorTextField : styles.textField
          }
        >
          {poojaItemsList.map((item, index) => (
            <CustomMenuItem key={index} value={item.name}>
              {item.name}
            </CustomMenuItem>
          ))}
        </CustomSelect>
        {errorMessage.poojaTitle ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage.poojaTitle}
          </Typography>
        ) : (
          ""
        )}
      </FormControl>
    );
  };

  const handleOpenDialog = () => {
    setOpenCancelDialog(true);
  };

  const handleCancelDialogClose = () => {
    setOpenCancelDialog(false);
  };

  const handleDatePickerClick = () => {
    setDatePickerOpen(true);
  };
  useEffect(() => {
    setDatePickerOpen(false);
  }, [currentItem.dateOfPooja]);

  const BasicDatePicker = (): React.ReactElement => {
    return (
      <div style={{ minWidth: "100%", borderRadius: "8px" }}>
        <StyledDateContainer
          sx={{
            // backgroundColor: "#FFF9E4",
            borderRadius: "8px",
            height: "48px",
          }}
          onClick={handleDatePickerClick}
          id="dateOfPooja"
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                open={isDatePickerOpen}
                onClose={() => setDatePickerOpen(false)}
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  currentItem.dateOfPooja
                    ? dayjs(currentItem.dateOfPooja, "MM-DD-YYYY")
                    : ""
                }
                disablePast
                onChange={(value) => {
                  const selectedDate = dayjs(value as string, "MM-DD-YYYY");
                  const currentDate = dayjs(); // current date
                  if (selectedDate.isBefore(currentDate, "day")) {
                    setErrorMessage({
                      ...errorMessage,
                      dateOfPooja: "Please select a future date.",
                    });
                  } else {
                    // If the selected date is valid, update the state and clear error message
                    handleDateChange("dateOfPooja", value);
                    setErrorMessage({ ...errorMessage, dateOfPooja: "" });
                  }
                }}
                className={
                  errorMessage.dateOfPooja
                    ? styles.errorTextField
                    : styles.textField
                }
              />
            </DemoContainer>
          </LocalizationProvider>
          {errorMessage.dateOfPooja ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.dateOfPooja}
            </Typography>
          ) : (
            ""
          )}
        </StyledDateContainer>
      </div>
    );
  };

  const navigateBack = () => {
    getCartItems();
    setShowDeities(false);
    setShowDetails(false);
  };

  const handleCart = (): void => {
    if (cartItemsList.length > 0) {
      setShowList(true);
    } else {
      setShowList(false);
    }
  };

  const cartContainer = () => {
    return (
      <div className={styles.maincontainer}>
        <Typography
          className={styles.heading}
          sx={{ margin: "0px !important" }}
        >
          Pooja Booking Request
        </Typography>
        <div className={styles.cartContainer}>
          <div className={styles.text}>Devotee Cart</div>
          <IconButton aria-label="cart" onClick={handleCart}>
            <CustomBadge badgeContent={cartItemsList.length} color="secondary">
              <img src={cartIcon} alt="cart Icon" />
            </CustomBadge>
          </IconButton>
        </div>
      </div>
    );
  };

  const handleCheckboxChange = (label: number) => {
    const isSelected = selectedDeityIds.includes(label);
    setDeityError("");
    if (isSelected) {
      setSelectedDeityIds(selectedDeityIds.filter((item) => item !== label));

      // setSelectedItems(selectedDeityIds.filter((item) => item !== label));
    } else {
      setSelectedDeityIds([...selectedDeityIds, label]);
      // setSelectedItems([...selectedDeityIds, label]);
    }
    setSelectedItems((prevSelectedItems) => {
      if (prevSelectedItems.includes(label)) {
        return prevSelectedItems.filter((item) => item !== label);
      } else {
        return [...prevSelectedItems, label];
      }
    });
  };

  const calculateDonationAmount = (currentItem: any): number => {
    const isSelected = selectedItems.length > 0;
    const donationAmount = parseFloat(currentItem.donationAmount);
    return isSelected ? selectedItems.length * donationAmount : donationAmount;
  };

  const calculateDuration = (currentItem: any): number => {
    const isSelected = selectedItems.length > 0;
    const poojaDuration = parseFloat(currentItem.poojaDuration);
    return isSelected ? selectedItems.length * poojaDuration : poojaDuration;
  }


  const handleDonationAmountChange = (inputValue: any) => {
    if (inputValue === "") {
      setDonationAmount(inputValue);
      setErrorMessage({
        ...errorMessage,
        donationAmount: "Donation amount is required",
      });
    } else if (Number(inputValue) < 1) {
      setDonationAmount(inputValue);
      setErrorMessage({
        ...errorMessage,
        donationAmount: "Minimum donation amount is 1",
      });
    } else if (inputValue <= maxFieldLimit) {
      setDonationAmount(inputValue);
      setErrorMessage({
        ...errorMessage,
        donationAmount: "",
      });
    } 
    // else {
    //   setErrorMessage({
    //     ...errorMessage,
    //     donationAmount: "Maximum donation amount reached",
    //   });
    // }
  };
  
  

  const fieldsOnAdd = () => {
    return (
      <div className={styles.fieldsRow}>
        {showPriestDropdown ? (
          <div id="selectPriest">
            {CustomRequiredInputLabel("Select Priest", true)}
            {priestListDropdown()}
          </div>
        ) : (
          ""
        )}
        <div>
          {CustomRequiredInputLabel("Suggested Donation Amount", true)}
          <CustomTextFeild
            id="DonationAmount"
            fullWidth
            required
            value={donationAmount.toString()}
            // onChange={(e) =>
            //   handleFieldChange("donationAmount", e.target.value)
            // }
            onChange={(e) => handleDonationAmountChange(e.target.value.replace(/[^0-9.]/g, ''))}
            className={
              errorMessage.donationAmount
                ? styles.errorTextField
                : styles.textField
            }
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AttachMoneyOutlinedIcon />
                </InputAdornment>
              ),
              // readOnly: true,
            }}
            placeholder="Enter Donation Amount"
          />
          {errorMessage.donationAmount && (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.donationAmount}
            </Typography>
          )}
        </div>
        <div>
          {CustomRequiredInputLabel("Pooja Duration (min)", true)}
          <CustomTextFeild
            id="poojaDuration"
            fullWidth
            required
            // value={currentItem.poojaDuration}
            value={duration.toString()}
            onChange={(e) => handleFieldChange("poojaDuration", e.target.value)}
            InputProps={{
              readOnly: true,
            }}
            className={styles.textField}
            placeholder="Enter Pooja Duration"
          />
        </div>
      </div>
    );
  };

  const fieldsComponent = () => {
    return (
      <form className={styles.fieldsContainer} onKeyDown={handleKeyPress}>
        <div className={styles.fieldsRow}>
          <div>
            {CustomRequiredInputLabel("Name", true)}
            <CustomTextFeild
              id="name"
              fullWidth
              required
              value={getUserDetails()?.toUpperCase()}
              className={
                errorMessage.name ? styles.errorTextField : styles.textField
              }
              InputProps={{
                readOnly: true,
              }}
            />
            {errorMessage.name && (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.name}
              </Typography>
            )}
          </div>
        </div>
        <div className={styles.fieldsRow}>
          <div>
            {CustomRequiredInputLabel("Pooja Location", true)}
            <CustomRadioButton
              checked={currentItem.poojaLocation === "TEMPLE_POOJA"}
              onChange={() => {
                handleFieldChange("poojaLocation", "TEMPLE_POOJA");
                setErrorMessage({ ...errorMessage, poojaLocation: "" });
                setShowDeities(false);
                setShowDetails(false);
                setCurrentItem({
                  name: getUserName() || "",
                  poojaLocation: "TEMPLE_POOJA",
                  poojaTitle: "",
                  deities: "",
                  dateOfPooja: dayjs().format("MM-DD-YYYY"),
                  donationAmount: 0,
                  poojaTime: dayjs().format("hh:mm A"),
                  selectPriest: "",
                  poojaDuration: 0,
                });
              }}
              id="templeLocation"
            />
            <label className={styles.label}>Temple Pooja</label>
            <CustomRadioButton
              checked={currentItem.poojaLocation === "OUTSIDE_POOJA"}
              onChange={() => {
                handleFieldChange("poojaLocation", "OUTSIDE_POOJA");
                setErrorMessage({ ...errorMessage, poojaLocation: "", poojaTime:"" });
                setShowDeities(false);
                setShowDetails(false);
                setCurrentItem(prevFormData => ({
                 ...prevFormData,
                  dateOfPooja: dayjs().format("MM-DD-YYYY"),
                  poojaTime: dayjs().format("hh:mm A"),
                }))
              }}
              id="outLocation"
            />
            <label className={styles.label}>Outside Pooja</label>
          </div>
          <div id="SelectPooja">
            <div className={styles.detailsLink}>
              {CustomRequiredInputLabel("Select Pooja", true)}
              <p
                style={{ 
                  color: selectedPoojaId ? "blue" : "#73737e",
                  margin: "0 0 2px",
                  cursor: selectedPoojaId ? "pointer" : "not-allowed"
                }}
                // onClick={handleOpenDialog}
                onClick={selectedPoojaId ? handleOpenDialog : ()=>{}}
              >
                Details
              </p>
            </div>
            {poojaTypesDropdown()}
          </div>
        </div>

        {showDeities && poojaDeitiesList.length > 0 ? (
          <div id="deitiesList">{deitiesListComponent()}</div>
        ) : (
          ""
        )}
        <div className={styles.fieldsRow}>
          <div id="poojadate">
            {CustomRequiredInputLabel("Pooja Date", true)}
            {BasicDatePicker()}
          </div>
          <div id="poojaTime">
            <HcccTimePicker
              handleFieldChange={handleFieldChange}
              labelName="Pooja Time"
              fieldName="poojaTime"
              className={
                errorMessage.poojaTime
                  ? styles.errorTextField
                  : styles.textField
              }
              value={currentItem.poojaTime}
            />
            {errorMessage.poojaTime ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.poojaTime}
              </Typography>
            ) : (
              ""
            )}
          </div>
        </div>
        {showDeities ? fieldsOnAdd() : ""}
      </form>
    );
  };

  const handleClose = () => {
    setIsOpen(false);
    setSelectedId(null);
  };

  const handleAgree = () => {
    if (selectedId !== null) {
      // Find the index of the item with the selected ID in the addedItemsList
      apiRequest({
        method: "DELETE",
        includeToken: true,
        endpoint: `${apiPath.deleteCartItem}/${selectedId}`,
      })
        .then((res) => {
          getCartItems();
          // Close the dialog
          handleClose();
          // toast.custom(<ToastSuccess message={LOCALE.ITEM_DELETED} />);
          toast.custom(
            <SuccessPopup
              headerMessage="Cart Items"
              showMessage={LOCALE.ITEM_DELETED}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
            />,
            {
              duration: constants.TOAST_POPUP_DURATION,
            }
          );
        })
        .catch((err) => {
          console.log(err);
          toast.custom(
            <ErrorPopup
              showMessage={catchErrorMessageHandler(err)}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
            />,
            {
              duration: constants.TOAST_POPUP_DURATION,
            }
          );
        });
    }
  };

  const dialogPopup = () => {
    return (
      <Dialog
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            height: "calc(100% - 128px)",
            width: "calc(100% - 128px)",
            margin: "64px",
            maxWidth: "504px",
            maxHeight: "180px",
          },
        }}
      >
        <div className={styles.closeIcon} onClick={handleClose}>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 1,
              top: 2,
              color: (theme: any) => theme.palette.grey[500],
            }}
          >
            <CloseIcon sx={{ color: "white" }} />
          </IconButton>
        </div>
        <DialogTitle className={commonStyles.dialogTitle}>
          {"Please Confirm"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-slide-description"
            className={commonStyles.dialogContext}
          >
            Are You Sure want to Delete the Item from the Cart?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <CommonOutlinedButton onClick={handleClose}>No</CommonOutlinedButton>
          <CommonButton onClick={handleAgree}>Yes</CommonButton>
        </DialogActions>
      </Dialog>
    );
  };

  const openConfirmPopUp = (id: number | undefined | null) => {
    setSelectedId(id);
    setIsOpen(true);
  };

  const tableDataComponent = () => {
    return (
      <div>
        <div className={styles.backArrow}>
          <div onClick={navigateBack} style={{ marginRight: "10px" }}>
            <CustomLeftIcon />
          </div>
          <Typography className={styles.heading}>List of Item Added</Typography>
        </div>
        {cartItemsList.length > 0 ? (
          <table className={styles.tableContainer}>
            <thead>
              <tr className={styles.headerTableRow}>
                <th className={styles.tableHorizontal}>Type</th>
                <th className={styles.tableHorizontal}>Priest Name</th>
                {/* <th className={styles.tableHorizontal}>Pooja Title</th> */}
                <th className={styles.tableHorizontal}>Deities</th>
                <th className={styles.tableHorizontal}>Date of Pooja</th>
                <th className={styles.tableHorizontal}>Donation Purpose</th>
                <th className={styles.tableHorizontal}>Donation Amount</th>
                <th className={styles.tableHorizontal}>Tangible Amount</th>
                <th className={styles.tableHorizontal}>Action</th>
              </tr>
            </thead>
            <tbody className={styles.tableBody}>
              {cartItemsList.map((item: cartItemListProps, index: number) => (
                <tr key={index} className={styles.tableRow}>
                  <td className={styles.tableDiagonal}>{item?.type}</td>
                  <td className={styles.tableDiagonal}>{item.priestName}</td>
                  <td className={styles.tableDiagonal}>
                    {item?.deities?.map((diety) => (
                      <>
                        {diety}
                        <br />
                      </>
                    ))}
                  </td>
                  <td className={styles.tableDiagonal}>{item?.dateOfPooja}</td>
                  <td className={styles.tableDiagonal}>
                    {item?.donationPurpose}
                  </td>
                  <td className={styles.tableDiagonal}>
                    {formatAmount(item.amount)}
                  </td>
                  <td className={styles.tableDiagonal}>
                    {formatAmount(item?.tangibleAmount)}
                  </td>
                  <td className={styles.tableDiagonal}>
                    <img
                      src={deleteIcon}
                      onClick={() => openConfirmPopUp(item?.id)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No Items Selected</p>
        )}
        {cartItemsList.length > 0 && (
          <div className={styles.totalAmount}>
            <p>Total {formatAmount(totalDonationAmount)}</p>
          </div>
        )}
      </div>
    );
  };

  const paymentComponent = () => {
    return (
      <>
        <CommonButton
          sx={{ marginTop: "20px" }}
          disabled={cartItemsList.length === 0 || paymentButton}
          onClick={handleMakePayment}
        >
          Make Payment
        </CommonButton>
      </>
    );
  };

  const [showButton, setShowButton] = useState(true);
  const handlePrint = () => {
    setShowButton(false);
    setTimeout(() => {
      window.print();
      setShowButton(true);
    }, 0);
  };

  const listComponentAndPayment = () => {
    return (
      <div style={{ width: "100%" }}>
        {tableDataComponent()}
        {cartItemsList.length > 0 && (
          <ModeofPayment setButtonDisable={setpaymentButton} />
        )}
        {paymentComponent()}
        {dialogPopup()}
      </div>
    );
  };


  const render = () => {
    return (
      <>
        {cartContainer()}
        {fieldsComponent()}
        {buttonsComponent()}
      </>
    );
  };

  function convertDateFormat(dateString: any) {
    const parts = dateString.split('-');
    return parts[0] + '/' + parts[1] + '/' + parts[2];
  }

  const handleTimeChangeSetErrors = (timeRange: any) => {
    handlePoojaTimeChangeSetErrors({
      ...timeRange,
      currentItem,
      errorMessage,
      duration,
      setErrorMessage,
      setButtonDisable,
    });
  }

  useEffect(() => {
    if (
      currentItem.poojaTime &&
      currentItem.poojaLocation === "OUTSIDE_POOJA"
    ) {
      handleTimeChangeSetErrors(constants.OUTSIDE_POOJA_TIMINGS);
    } else {
      if (currentItem.poojaTime) {
        if (currentItem.dateOfPooja) {
          apiRequest({
            method: "POST",
            endpoint: apiPath.dailyTempleActivity,
            params: {
              scheduleDate: convertDateFormat(currentItem.dateOfPooja),
            },
          })
            .then((res) => {
              const timeRange = getStartTimeAndEndTime(
                res.data.dailyActivities
              );
              if (timeRange) {
                handleTimeChangeSetErrors(timeRange);
              }
            })
            .catch((err) => {
              handleTimeChangeSetErrors(constants.TEMPLE_TIMINGS);
              console.error(err);
            });
        } else {
          handleTimeChangeSetErrors(constants.TEMPLE_TIMINGS);
        }
      }
    }
  }, [currentItem.dateOfPooja, currentItem.poojaTime, duration]);

  const PoojaDetailsComponent = () => {
   
    const selectedPooja = poojaItemsList.find(
      (item) => item.id === selectedPoojaId
    );

    return (
      <>
        <Grid >
          {/* <Grid>{poojaTypesDropdown()}</Grid> */}
          {selectedPooja && (
            <table className={styles.tableDetailsContainer}>
              <tr className={styles.headerTableRow}>
                <td className={styles.headerTableColumn}>Pooja Title</td>
                <td className={styles.contentTableColumn}>
                  : {selectedPooja.name}
                </td>
              </tr>
              <tr className={styles.headerTableRow} style={{ verticalAlign: "top" }}>
                <td className={styles.headerTableColumn}>Description/Material</td>
                <td className={styles.contentTableColumn}>: {!isNil(selectedPooja.description) ? selectedPooja.description : "-"}</td>
              </tr>
              <tr className={styles.headerTableRow}>
                <td className={styles.headerTableColumn}>Duration</td>
                <td className={styles.contentTableColumn}>
                  : {duration.toString()}
                </td>
              </tr>
              <tr className={styles.headerTableRow}>
                <td className={styles.headerTableColumn}>Suggested Donation</td>
                <td className={styles.contentTableColumn}>: {donationAmount.toString()}</td>
              </tr>
              <tr className={styles.headerTableRow}>
                <td className={styles.headerTableColumn}>Priest Required</td>
                <td className={styles.contentTableColumn}>
                  : {selectedPooja.priestRequired ? "Yes" : "No"}
                </td>
              </tr>
            </table>
          )}
        </Grid>
        {showButton &&<Grid sx={{ marginTop: "10px" }}>
          <CommonButton onClick={handlePrint} className={styles.printHidden} >
            {/* {loader ? "Loading...." : "Print"} */}
            Print
          </CommonButton>
        </Grid>}
      </>
    );
  };

  return (
    <div className={styles.bookPoojaContainer}>
      {getHeaders() ? (
        <Typography component="div" className={styles.typoGraphyHeading}>
          Devotee Service
        </Typography>
      ) : (
        ""
      )}
      {getHeaders() ? (
        <Typography component="div" className={styles.typoGraphy}>
          Pooja Booking
        </Typography>
      ) : (
        ""
      )}
      <Toaster /> {!showList ? render() : <CartComponent navigateBack={navigateBack}/>}
      <Dialog
        open={openCancelDialog}
        onClose={handleCancelDialogClose}
        aria-labelledby="cancel-dialog-title"
        PaperProps={{
          style: {
            height: "calc(100% - 128px)",
            width: "calc(100% - 128px)",
            margin: "64px",
            maxWidth: "804px",
            maxHeight: "400px",
            overflowY: "hidden",
            borderTopLeftRadius: "16px",
            borderTopRightRadius: "16px",
          },
        }}
      >
        {/* {loading ? <ClipLoader /> : null} */}
        <div
          style={{
            backgroundColor: "#882E14",
            width: "auto",
          }}
        >
          <DialogTitle
            sx={{ fontWeight: 700, fontSize: "16px", color: "white" }}
          >
            {"Pooja Details"}
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleCancelDialogClose}
            sx={{
              position: "absolute",
              right: 24,
              top: 8,
              color: (theme: any) => theme.palette.grey[500],
            }}
          >
            <CloseIcon sx={{ color: "white" }} />
          </IconButton>
        </div>
        <DialogContent>
          {loading ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <BounceLoader color="#22A699" loading={loading} size={45} />
              <span
                style={{
                  marginLeft: "8px",
                  fontSize: "15px",
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                Please wait...
              </span>
            </div>
          ) : (
            <div>
              {PoojaDetailsComponent()}
              {/* {donationSummeryList.length > 0 ? (
                  poojaDetailsComponent()
                ) : (
                  <Typography sx={{ textAlign: "center" }}>No Data</Typography>
                )} */}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default DevoteeBookPooja;
